// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"a7a176aa","787":"eafa8d91"}[chunkId] + ".chunk.js";
};